import { React, useCallback, useState, useRef, useEffect } from "react";
import "./PopUpSearch.css";
import {
  Badge,
  Card,
  ResourceItem,
  ResourceList,
  Text,
  TextField,
  Button,
} from "@shopify/polaris";

import debounce from "lodash.debounce";

import { XIcon } from "@shopify/polaris-icons";
import supabase from "../../../supabase-client";
import { blockReasonLabel } from "../../../utility/clientBlocks";

function PopUpSearch({ activated, setOpen, getCustomer, title, dbFunction }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dataToShow, setDataToShow] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleSearchQuery = (value) => {
    setLoading(true);
    setSearchQuery(value);
    debouncedSearch(value);
  };

  const debouncedSearch = useCallback(
    debounce(async (query) => {
      const { data, error } = await supabase.rpc(dbFunction, {
        search_text: query?.trim() || "",
      });
      if (error) {
        console.error(error);
      }
      setDataToShow(data);
      setLoading(false);
    }, 1000),
    []
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  if (!activated) {
    return <></>;
  }

  return (
    <>
      <div
        className="popup_search_blurred_bg"
        onClick={() => {
          setOpen(false);
        }}
      ></div>
      <div className="popup_search_window">
        <Card>
          <div style={{ display: "flex", marginBottom: "0.5rem" }}>
            <Text variant="headingMd">Buscar {title}</Text>
            <span style={{ width: "25px", marginLeft: "auto" }}>
              <Button
                icon={XIcon}
                variant="plain"
                onClick={() => {
                  setOpen(false);
                }}
              />
            </span>
          </div>

          <TextField
            placeholder="Buscar"
            value={searchQuery}
            onChange={handleSearchQuery}
            loading={loading}
            focused
          />
          <div
            style={{
              marginTop: "0.5rem",
              borderRadius: "0.3rem",
              overflow: "hidden",
            }}
          >
            <ResourceList
              items={dataToShow}
              onSelectionChange={(item) => {}}
              renderItem={(item) => {
                const { id, first_name, last_name, email, phone, blocked, block_reason } =
                  item;
                return (
                  <ResourceItem
                    id={id}
                    onClick={(id) => {
                      const name = first_name + " " + last_name;
                      getCustomer({ id, name, email, phone, blocked, block_reason });
                      setOpen(false);
                    }}
                  >
                    <div
                      style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
                    >
                      <Text>
                        {first_name} {last_name}
                      </Text>
                      {blocked && (
                        <Badge size="small" tone="critical">
                          {`Bloqueado · ${blockReasonLabel(block_reason)}`}
                        </Badge>
                      )}
                    </div>
                    <Text>{email || phone}</Text>
                  </ResourceItem>
                );
              }}
            />
          </div>
        </Card>
      </div>
    </>
  );
}

export default PopUpSearch;
